import React, { useState } from "react";

import Navbar from "../components/TopNav";
import Footer from "../components/Footer";

import monos from "../images/mechanics/monos.png";
import group from "../images/mechanics/group.png";
import pankak from "../images/buy/pankak.png";

const Toknomics = () => {
  const [type, setType] = useState("toknomics");
  const toknomicArray = [
    {
      distribution: "SEED ROUND",
      price: "0.10",
      percent: "7%",
      tokens: "7,000,000",
      total: "$700,000",
    },
    {
      distribution: "STRATEGIC ROUND",
      price: "0.13",
      percent: "5%",
      tokens: "5,000,000",
      total: "$650,000",
    },
    {
      distribution: "IDO ROUND",
      price: "0.15",
      percent: "3%",
      tokens: "3,000,000",
      total: "$450,000",
    },
    {
      distribution: "LIQUIDITY",
      price: "-",
      percent: "5%",
      tokens: "5,000,000",
      total: "-",
    },
    {
      distribution: "CORE TEAM",
      price: "-",
      percent: "20%",
      tokens: "20,000,000",
      total: "-",
    },
    {
      distribution: "ADVISORS",
      price: "-",
      percent: "15%",
      tokens: "15,000,000",
      total: "-",
    },
    {
      distribution: "PLAY TO EARN",
      price: "-",
      percent: "30%",
      tokens: "30,000,000",
      total: "-",
    },
    {
      distribution: "ECONOMY FUND",
      price: "-",
      percent: "15%",
      tokens: "15,000,000",
      total: "-",
    },
  ];
  const array = [
    { holding: "TBA", time: "TBA", reward: "TBA", lottery: "TBA" },
    { holding: "TBA", time: "TBA", reward: "TBA", lottery: "TBA" },
    { holding: "TBA", time: "TBA", reward: "TBA", lottery: "TBA" },
    { holding: "TBA", time: "TBA", reward: "TBA", lottery: "TBA" },
    { holding: "TBA", time: "TBA", reward: "TBA", lottery: "TBA" },
  ];

  return (
    <div className="row no-gutters game-mechanics">
      <Navbar />
      <div className="col-12 main">
        <button
          onClick={() => setType("toknomics")}
          className={`${type === "toknomics" ? "active-btn" : ""} btn`}
        >
          TOKENOMICS
        </button>
        <button
          onClick={() => setType("nftnomics")}
          className={`${type === "nftnomics" ? "active-btn" : ""} btn`}
        >
          NFT NOMICS
        </button>
        <div className="row no-gutters">
          {type === "toknomics" && (
            <>
              <div className="col-12">
                <div className="top-div">
                  <img src={monos} alt="" />
                  <span>TOTAL SUPPLY:</span>
                  <h2>100,000,000 $MONS</h2>
                </div>
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>TOKEN DISTRIBUTION</th>
                        <th>%</th>
                        <th>PRICE ($)</th>
                        <th>TOKENS ($MONS)</th>
                        <th>TOTAL RAISE ($)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {toknomicArray.map((arr) => (
                        <tr>
                          <td>{arr.distribution}</td>
                          <td>{arr.percent}</td>
                          <td>{arr.price}</td>
                          <td>{arr.tokens}</td>
                          <td>{arr.total}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div className="bottom-div">
                    <p className="first-p">TOTAL RAISE</p>
                    <p>$1,800,000</p>
                  </div>
                </div>
              </div>
              <div className="col-12">
                <h1 className="heading">VESTING SCHEDULE</h1>
                <img className="group-img" src={group} alt="" />
                <h1 className="heading">KEY INDICATORS</h1>
                <div className="table-responsive last">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>LISTING EXCHANGE</th>
                        <th>INITIAL MARKET CAP</th>
                        <th>DILUTED MARKET CAP</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="change-tr">
                        <td>
                          <img src={pankak} alt="" />
                        </td>
                        <td className="sec-td">
                          <div>
                            <span>LISTING PRICE</span>
                            <p>$ 0.15</p>
                          </div>
                          X
                          <div>
                            <span>$MONS AT TGE</span>
                            <p>1,620,000</p>
                          </div>
                          =<h3>$243,000</h3>
                        </td>
                        <td>$15,000,000</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          )}
          {type === "nftnomics" && (
            <div className="col-12">
              <div className="table-responsive last">
                <table className="table">
                  <thead>
                    <tr>
                      <th>
                        $MONS TOKENS <br /> REQUIRED FOR STAKING
                      </th>
                      <th>TIME PERIOD</th>
                      <th>REWARD EVERY MONTH</th>
                      <th>CHANCE TO WIN NFT LOTTERY</th>
                    </tr>
                  </thead>
                  <tbody>
                    {array.map((arr) => (
                      <tr>
                        <td>{arr.holding}</td>
                        <td>{arr.time}</td>
                        <td>{arr.reward}</td>
                        <td>{arr.lottery}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Toknomics;
